import StaticSelector from "components/Atoms/StaticSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import useAuth from "hooks/useAuth"
import React from "react"
import { useFilter } from "store/search-filter/search-filter.reducer"

const SellableItemFilter = () => {
  const [filter, setFilter] = useFilter("sellable-items")
  const { user } = useAuth()
  // useShallowEffect(() => {
  //   if (isEmpty(filter)) {
  //     setFilter({
  //       department: user?.currentDepartment,
  //     })
  //   }
  // }, [filter])
  return (
    <SearchFilter
      className="ml-3"
      value={filter}
      getValues={values => {
        setFilter(values)
      }}
      onClear={() => setFilter({})}
    >
      <SearchFilterCallout title="Department">
        <StaticSelector
          inline
          className="mb-0 mt-3"
          path="department"
          items={user?.departments}
        />
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default SellableItemFilter
